export default __webpack_public_path__ + "static/deportes-icon--white-fb33ccb7b855abf261f5fd23dda39eea.svg";